export default __webpack_public_path__ + "static/b0417299-cd03-4eb8-a744-f7bfa9ebc1bd-acef648363c084dd99a4167d696be4eb.ttf";